module.exports = __webpack_public_path__ + "static/media/east_channel.6bf8f87c.png";